// Popover content is inset by tw:p-2.5 (the shadcn popover base); full-bleed
// rules inside undo it with the matching negative margin.
export const SURFACE_BLEED_CLASS = 'tw:-mx-2.5'
// Sides and top, never the tw:p-N shorthand: a shorthand on DrawerContent
// defeats its pb-safe-3 home-indicator inset — see the @utility note in
// customUtilities.css.
export const SHEET_INSET_CLASS = 'tw:px-2.5 tw:pt-2.5'
